import $ from "jquery";

$(function (){

	// automaticke nastaveny max-height na vysku 5 parametru v detailu produktu
	// + script pro rozbaleni a sbaleni seznamu
	// viz. https://www.autochladek.cz/cz/produkt/autobaterie-autopart-galaxy-gold-12v-77ah-800a-en/
	if ($("#product_data_wrap .product_data tr").length > 5) {
		let height = 0;
		$("#product_data_wrap .product_data tr").each(function(index) {
			height = height + $(this).outerHeight(true);
			return index < 4;
		});
		$("#product_data_wrap").css("max-height", height);
	}

	$(".display_params").click(function() {
		$("#product_data_wrap").animate({
			'max-height': '1000px'
		}, 500, function() {
			$(".display_params").fadeOut(200, function() {
				$(".hide_params").fadeIn(200);
			});
		});
	});

	$(".hide_params").click(function() {
		$("#product_data_wrap").animate({
			'max-height': '194px'
		}, 500, function() {
			$(".hide_params").fadeOut(200, function() {
				$(".display_params").fadeIn(200);
			});
		});
	});

/////////////////////////////////////////////////

	// rozbalovani a sbalovani inputu pro dorucovaci adresu
	$("#useShippingAddress").on("change", function() {
		$("#shippingAddress").toggle();
	});

	if ($("#useShippingAddress").attr("checked") == "checked") {
		$("#shippingAddress").toggle();
	}

///////////////////////////////////////////////////

	// carousel nahledovych obrazku, pokud ma produkt vic obrazku
	// TODO - urcite nahradit za novy carousel plugin, nebo smazat
	// TODO vyhodit plugin z vendor/jquery.plugins-original.js
	//viz. https://www.autochladek.cz/cz/produkt/lampa-zadni-multipoint-ii-leva/

	$(".gallery_carousel").jCarouselLite({
		btnNext: ".gallery_next",
		btnPrev: ".gallery_prev",
		circular: false,
		visible: 1
	});

//////////////////////////////////////////////////////

	// Magnific Popup pro obrazky
	// rozkliknuti obrazku na celou obrazovku
	// TODO - nahradit za novejsi plugin
	// TODO vyhodit plugin z vendor/jquery.plugins-original.js
	$("a[href$='jpg'], a[href$='png'], a[href$='gif'], a[href$='bmp'], a[href$='JPG'], a[href$='PNG'], a[href$='GIF'], a[href$='BMP'], .nyromodal").magnificPopup({
		type: 'image',
		image: {
			markup: '<div class="mfp-close"></div>' +
				'<div class="mfp-figure">' +
				'<div class="mfp-img"></div>' +
				'<div class="mfp-bottom-bar">' +
				'<div class="mfp-title"></div>' +
				'<div class="mfp-counter"></div>' +
				'</div>' +
				'</div>',
		},
		gallery: {
			enabled: true
		},
		closeMarkup: '<button title="%title%" class="mfp-close"></button>'
	});

//////////////////////////////////////////////////////

	// Uniform select - nejake hezke selecty
	// TODO - vyhodit i plugin z vendor/jquery.plugins-original.js
	$("select").uniform();

//////////////////////////////////////////////////////

	// Slider v katalogu
	// TODO nahradit js Cycle2 plugin za novejsi
	// TODO - vyhodit plugin z vendor/jquery.plugins-original.js
	if ($('#slider #slides .slide').length > 1) {
		$("#slider").append('<div id="slider-pager" />');
		$('#slides').cycle({
			timeout: 4000,
			pager: '#slider-pager',
			slides: '> .slide',
			fx: 'scrollHorz'
		});
	}

/////////////////////////////////////////////////////////

	// souvisejici produkty - carousel
	// jsou v detailu produktu a v okne po pridani produktu do kosiku
	// Tag list carousel
	// if ($('.tag_list .tag_list_carousel ul li').length > 1) {
	// 	$(".tag_list .tag_list_carousel").jCarouselLite({
	// 		btnNext: ".tag_list_next",
	// 		btnPrev: ".tag_list_prev",
	// 		visible: 3,
	// 		circular: false
	// 	});
	// }

	// if ($('.tag_list .tag_list_carousel--modal ul li').length > 3) {
	// 	$(".tag_list--modal").jCarouselLite({
	// 		btnNext: ".tag_list_next",
	// 		btnPrev: ".tag_list_prev",
	// 		visible: 3,
	// 		circular: false
	// 	});
	// }

////////////////////////////////////////////////////////////


});


